import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MyButtonComponent } from '../../buttons/my-button/my-button.component';
import { CommonModule } from '@angular/common';

export interface DialogData {
  hours: {
    min: number,
    max: number,
    step: number
  },
  minutes: {
    min: number,
    max: number,
    step: number
  },
  seconds: {
    min: number,
    max: number,
    step: number
  },
  showSeconds: boolean
  showLabels: boolean
}

const TIME_SETTINGS: DialogData = {
  hours: {
    min: 0,
    max: 23,
    step: 1
  },
  minutes: {
    min: 0,
    max: 59,
    step: 5
  },
  seconds: {
    min: 0,
    max: 59,
    step: 15
  },
  showSeconds: true,
  showLabels: false,
}

@Component({
  selector: 'app-get-time',
  templateUrl: 'get-time.component.html',
  styleUrl: './get-time.component.css',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MyButtonComponent
  ],
})
export class GetTimeComponent {
  hours: number = 12;
  minutes: number = 0;
  seconds: number = 0;

  constructor(
    public dialogRef: MatDialogRef<GetTimeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {
    this.data = { ...TIME_SETTINGS, ...this.data };
  }

  onCloseClick(): void {
    this.dialogRef.close();
  }

  onIncrementClick(field: 'hours' | 'minutes' | 'seconds', increment: number = 1) {
    this[field] = this[field] + ((this.data[field].step ? this.data[field].step || 1 : 1) * increment)
    if (this[field] > TIME_SETTINGS[field].max) {
      this[field] = TIME_SETTINGS[field].min
    }
    if (this[field] < TIME_SETTINGS[field].min) {
      this[field] = (TIME_SETTINGS[field].max + 1) - (this.data[field].step || 1)
    }
  }
}
